import type { IntlShape } from 'react-intl/src/types';

import type { CollectionData } from '@/integrations/contentful';
import type { Paths } from '@/lib/paths';
import { commonMessages } from '@/messages/common';

import type { CardProps } from './types';

export const transformCollectionData = (
  saleorData: CollectionData[],
  paths: Paths,
  formatMessage: IntlShape['formatMessage'],
): Partial<CardProps> => {
  if (saleorData.length) {
    const collection = saleorData[0];
    return {
      urlText: formatMessage(commonMessages.discoverTheCollection),
      url: paths.watches.collection.asPath({
        slug: collection.slug,
      }),
      urlType: 'link',
    };
  }

  return {};
};

export const parseSaleorProductSku = (s: string | null | undefined) => {
  try {
    return JSON.parse(s ?? '{}');
  } catch (e) {
    return {};
  }
};
